'use client'

import Button from 'components/Buttons/Button/Button'
import paths from 'constants/paths'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import styles from './OurPortfolio.module.scss'

const IMAGES = [
  '/assets/about/project-showcase-acceligent.png',
  '/assets/about/project-showcase-audubon.png',
  '/assets/about/project-showcase-pista.png',
  '/assets/about/project-showcase-squad-locker.png',
]

const OurPortfolio = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % IMAGES.length)
    }, 4000)

    return () => clearInterval(interval)
  }, [])

  return (
    <section className={styles.container}>
      <div className={styles['text-content']}>
        <div>
          <h2>From Concept to Creation</h2>
          <p className={styles.subtitle}>How great work comes about</p>
        </div>

        <p className={styles.description}>
          We&apos;ve partnered with clients across industries—from construction to retail—creating platforms for both consumers and internal teams, united by
          openness, trust, and a drive for excellence.
        </p>

        <Link href={paths.work}>
          <Button>Explore Our Portfolio</Button>
        </Link>
      </div>

      <div className={styles['project-image']} style={{ backgroundImage: `url(${IMAGES[currentImageIndex]})` }} />
    </section>
  )
}

export default OurPortfolio
